import React from 'react';

import LoginCreds from '../../components/loginpages/LoginCreds';
import { TSPCategory, TSPConfig } from '../types';

const attConfig: TSPConfig = {
  key: 'att',
  name: 'AT&T',
  imageName: 'AT&T',
  category: TSPCategory.CUSTOM,
  helpText:
    'Input the credentials and database you use to log into the AT&T Web App.',
  loginComponent: (props) => (
    <LoginCreds
      onValidityChange={props.onValidityChange}
      fields={[
        { label: 'Username', name: 'username', type: 'text', required: true },
        {
          label: 'Password',
          name: 'password',
          type: 'password',
          required: true,
        },
        { label: 'Database', name: 'database', type: 'text', required: true },
      ]}
    />
  ),
};

export default attConfig;
